import React from "react";
import "./CardCarouselComcafundi.scss";

function CardCarouselcomfacundi({ item }: { item: any }) {
    return (
        <div className="">
            <div className={"container-img"}>
                <img src={item?.img} alt="" />
            </div>
            <div className={"container-card-comfacundi"}>
                <h4>{item?.title}</h4>
                <p>{item?.description}</p>
            </div>
        </div>
    );
}

export default CardCarouselcomfacundi;
